import React from "react";
import { Container } from "./styles";
import InstallButton from "../InstallButton";
import useFeaturedPlugins from "../Plugins/hooks/useFeaturedPlugins";
import { useHistory } from "react-router-dom";
import usePublicMode from "../../hooks/usePublicMode";

const MAX_NON_HERO_PLUGINS = 4;

export default function FeaturedPlugins({ pluginCategory, user }) {
  const { featuredPlugins, isLoading, error } = useFeaturedPlugins();
  const history = useHistory();
  const { urlPrefixPlugin } = usePublicMode();

  let hero,
    plugins = [],
    others = [],
    rows = [];

  if (featuredPlugins) {
    if (pluginCategory) {
      plugins = featuredPlugins.filter((plugin) => {
        return plugin.pluginCategoryId === pluginCategory.id;
      });
    } else {
      plugins = featuredPlugins;
    }

    plugins.sort((a, b) => a.order - b.order);

    hero = plugins.find((plugin) => plugin.hero);

    others = plugins
      .filter((plugin) => {
        return !plugin.hero;
      })
      .slice(0, MAX_NON_HERO_PLUGINS);
  }

  if (others) {
    rows = others.reduce((result, value, index, array) => {
      if (index % 2 === 0) result.push(array.slice(index, index + 2));
      return result;
    }, []);
  }

  const isLandscape = rows.length > 1;

  const goToPlugin = (plugin) => {
    return (E) => {
      console.log("here");
      history.push(`${urlPrefixPlugin}/${plugin.shortId}/${plugin.slug}`);
    };
  };

  return (
    <Container>
      {hero && (
        <div
          className="hero-card"
          style={{ background: hero.backgroundColor, color: hero.foregroundColor }}
          onClick={goToPlugin(hero.plugin)}
        >
          <div className="actions">
            <p>Read more</p>
            {user && (
              <InstallButton
                plugin={hero.plugin}
                buttonBackgroundColor={hero.foregroundColor} //
                buttonForegroundColor={hero.backgroundColor}
                titleCase={true}
                suppressRemove
                showPlus
                user={user}
              />
            )}
          </div>

          <div className="image-container">
            <img src={hero.imagePortraitUrl} />
          </div>
          <div className="name">{hero.name}</div>
          {hero.description && <div className="description">{hero.description}</div>}
          <div className="author-name">By {hero.authorName}</div>
        </div>
      )}
      <div className="other-cards">
        {rows.map((pluginPair) => (
          <>
            {isLandscape && (
              <div className="row-landscape">
                {pluginPair.map((plugin) => (
                  <div
                    className="card"
                    style={{ background: plugin.backgroundColor, color: plugin.foregroundColor }}
                    onClick={goToPlugin(plugin.plugin)}
                  >
                    <div className="actions">
                      <p>Read more</p>
                      {user && (
                        <InstallButton
                          titleCase={true}
                          plugin={plugin.plugin}
                          buttonBackgroundColor={plugin.foregroundColor} //
                          buttonForegroundColor={plugin.backgroundColor}
                          suppressRemove
                          showPlus
                          user={user}
                        />
                      )}
                    </div>
                    <div className="image-container">
                      <img src={plugin.imageLandscapeUrl} />
                    </div>
                    <div className="info">
                      <div className="name">{plugin.name}</div>
                      <div className="author-name">By {plugin.authorName}</div>
                      <div className="description">{plugin.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {!isLandscape && (
              <div className="row-portrait">
                {pluginPair.map((plugin) => (
                  <div
                    className="card"
                    style={{ background: plugin.backgroundColor, color: plugin.foregroundColor }}
                    onClick={goToPlugin(plugin.plugin)}
                  >
                    <div className="actions">
                      <p>Read more</p>
                      <InstallButton
                        titleCase={true}
                        plugin={plugin.plugin}
                        buttonBackgroundColor={plugin.foregroundColor} //
                        buttonForegroundColor={plugin.backgroundColor}
                        suppressRemove
                        showPlus
                        user={user}
                      />
                    </div>

                    <div className="image-container">
                      <img src={plugin.imagePortraitUrl} />
                    </div>
                    <div className="name">{plugin.name}</div>
                    {plugin.description && <div className="description">{plugin.description}</div>}
                    <div className="author-name">By {plugin.authorName}</div>
                  </div>
                ))}
              </div>
            )}
          </>
        ))}
      </div>
    </Container>
  );
}
